import { PersonalRoutingModule } from '@app/modules/personal/personal.routing';
import { MyAccountComponent } from '@app/modules/personal/pages/my-account/my-account.component';
import { SharedModule } from '@app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';


@NgModule({
    declarations: [
        MyAccountComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        PersonalRoutingModule
    ]
})
export class PersonalModule { }
